export default __webpack_public_path__ + "static/media/warning-orange.6909e36c.svg";